module.exports = __webpack_public_path__ + "static/media/no-internet.fd5253e5.svg";